
import { defineComponent } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import helpers from "@/helpers/global";
import Chart from "chart.js/auto";
import _ from "lodash";
import AssessmentsTable from "@/components/Table/AssessmentsAssessments.vue";
import {
  valueAndTraitsData,
  acceptableData,
} from "@/views/Assessments/mock_data_modal_value_and_traits";
import { Editor, EditorContent } from "@tiptap/vue-3";
import StarterKit from "@tiptap/starter-kit";

export default defineComponent({
  components: {
    AssessmentsTable,
    EditorContent,
  },
  title() {
    let name = "My Assessments";
    if (this.formTemplate) {
      name = (this as any).formTemplate.form_name;
    }
    return `${name} | My Culture`;
  },
  data() {
    return {
      bulkModalStatus: false,
      advancedInviteStatus: false,
      inviteButtonLoading: false,
      inviteBulkButtonLoading: false,
      assessmentsID: "",
      mutipleBulkEmail: "",
      inputBulkEmail: "",
      mutipleBulkValidteEmail: [""],
      form: {
        firstname: "",
        lastname: "",
        email: "",
      },
      formValidate: {
        email: false,
      },
      advancedForm: {
        subject: "You’ve been invited to an assessment",
        emailBody: null,
        emailSender: "MyCulture <no-reply@myculture.info>",
        recipients: [
          {
            firstname: "",
            lastname: "",
            email: "",
          },
          {
            firstname: "",
            lastname: "",
            email: "",
          },
          {
            firstname: "",
            lastname: "",
            email: "",
          },
          {
            firstname: "",
            lastname: "",
            email: "",
          },
          {
            firstname: "",
            lastname: "",
            email: "",
          },
          {
            firstname: "",
            lastname: "",
            email: "",
          },
        ],
      },
      // scoreSummaryLineData: [
      //   {
      //     name: "Mr. A",
      //     percentageOfBar: 40,
      //     value: 40,
      //     color: "red",
      //   },
      //   {
      //     name: "Mr. B",
      //     percentageOfBar: 60,
      //     value: 60,
      //     color: "yellow",
      //   },
      //   {
      //     name: "Mr. C",
      //     percentageOfBar: 89,
      //     value: 89,
      //     color: "green",
      //   },
      // ],
      // valueAndTraitsLineData: [
      //   {
      //     name: "Mr. A",
      //     percentageOfBar: 40,
      //     value: 40,
      //     color: "red",
      //   },
      //   {
      //     name: "Mr. B",
      //     percentageOfBar: 42,
      //     value: 60,
      //     color: "yellow",
      //   },
      //   {
      //     name: "Mr. C",
      //     percentageOfBar: 69,
      //     value: 89,
      //     color: "yellow",
      //   },
      // ],
      // valueAndTraitsDataDetail: [
      //   {
      //     label: "Values",
      //     value: 72,
      //     color: "yellow",
      //   },
      //   {
      //     label: "Traits",
      //     value: 85,
      //     color: "green",
      //   },
      // ],
      // cultureProfileLineData: [
      //   {
      //     name: "Mr. A",
      //     percentageOfBar: 12,
      //     value: 24,
      //     color: "red",
      //   },
      //   {
      //     name: "Mr. B",
      //     percentageOfBar: 42,
      //     value: 60,
      //     color: "yellow",
      //   },
      //   {
      //     name: "Mr. C",
      //     percentageOfBar: 69,
      //     value: 89,
      //     color: "green",
      //   },
      // ],
      // cultureProfileDataDetail: [
      //   {
      //     label: "Dominant Characteristics",
      //     value: 89,
      //     color: "yellow",
      //   },
      //   {
      //     label: "Organizational Glue",
      //     value: 40,
      //     color: "green",
      //   },
      //   {
      //     label: "Organizational Leadership",
      //     value: 38,
      //     color: "yellow",
      //   },
      //   {
      //     label: "Strategic Emphases",
      //     value: 40,
      //     color: "red",
      //   },
      //   {
      //     label: "Management of Employees",
      //     value: 42,
      //     color: "red",
      //   },
      //   {
      //     label: "Criteria of Success",
      //     value: 40,
      //     color: "green",
      //   },
      // ],
      // acceptableBehaviorsLineData: [
      //   {
      //     name: "Mr. A",
      //     percentageOfBar: 12,
      //     value: 24,
      //     color: "red",
      //   },
      //   {
      //     name: "Mr. B",
      //     percentageOfBar: 42,
      //     value: 60,
      //     color: "yellow",
      //   },
      //   {
      //     name: "Mr. C",
      //     percentageOfBar: 69,
      //     value: 89,
      //     color: "yellow",
      //   },
      // ],
      // acceptableBehaviorsDataDetail: [
      //   {
      //     label: "Scenario Alignment",
      //     value: 89,
      //     color: "yellow",
      //   },
      // ],
      inviteExpendStatus: false,
      inviteExpendHeight: 0,
      anlyticsExpendStatus: false,
      anlyticsExpendHeight: 0,
      valueAndTraitsModalStatus: false,
      valueAndTraitsSelected: "Values",
      valueAndTraitsMockData: [
        {
          name: "",
          label_en: "",
          id: "",
          percentage: 0,
          value: [
            {
              name: "",
              label_en: "",
              id: "",
              percentage: 0,
              candidate: [
                {
                  displayName: "",
                  name: "",
                  id: "",
                  color: "",
                },
              ],
            },
          ],
        },
      ],
      cultureProfileModalStatus: false,
      cultureProfileSelected: {
        id: "",
        label: "",
        value: "",
      },
      humanSkillsModalStatus: false,
      humanSkillsSelected: {
        id: "",
        label: "",
        value: "",
      },
      acceptableBehaviorsModalStatus: false,
      acceptableMockData: [
        {
          name: "",
          valuePercentage: 0,
          question: "",
          candidateValue: [
            {
              displayName: "",
              value: "",
            },
          ],
        },
      ],
      // acceptableData: [
      //   {
      //     name: "",
      //     valuePercentage: 0,
      //     question: "",
      //     candidateValue: [
      //       {
      //         displayName: "",
      //         value: "",
      //       },
      //     ],
      //   },
      // ],
      /*
      radarChartCandidateData: [
        {
          name: "jack Smith",
          data: [28, 31, 52, 29],
          color: "#30CCB4",
        },
        {
          name: "Allen Key",
          data: [18, 31, 42, 32],
          color: "#9CCC30",
        },
        {
          name: "Barbra Longely",
          data: [25, 31, 32, 34],
          color: "#2AEAF2",
        },
        {
          name: "Sam Lee",
          data: [24, 21, 52, 29],
          color: "#C452F7",
        },
      ],
      //*/
      radarChartCompanyData: [30, 22, 41, 36],
      radarChartVal: {},
      culturePreferenceRenderChart: false,
      culturePreferenceRenderChartValue: 1,
      culturePreferenceRenderChartFilter: [""],

      // Human Skills
      humanSkillsRadarChartVal: {},
      humanSkillsRenderChart: false,
      humanSkillsRenderChartValue: 1,
      humanSkillsRenderChartFilter: [""],

      // valueAndTraitsModalData: {},
      analyticsLoadingStatus: false,
      analyticsLoadedStatus: false,

      // @see https://trello.com/c/ByQq6vUm/1459-assessments-as-a-manager-i-want-to-group-analytics-for-culture-profile-so-that-i-easily-identify-areas-of-strengths-and-opportun
      avialableColors: [
        "#35e87c",
        "#407bb2",
        "#7867ce",
        "#f7e51d",
        "#d8658e",
        "#003f5c",
        "#58508d",
        "#bc5090",
        "#ff6361",
        "#ffa600",
        "#ff595e",
        "#ffca3a",
        "#8ac926",
        "#0ea5e9",
        "#6a4c93",
        "#00202e",
        "#003f5c",
        "#2c4875",
        "#8a508f",
        "#bc5090",
        "#ff6361",
        "#ff8531",
        "#ffa600",
        "#ffd380",
      ],
      // @see src\components\MainCardResults.vue
      tooltipOncultureStatus: true,
      tooltipOncultureLabelPrefix: "",
      tooltipOncultureLabel: {
        collaborate: "",
        create: "",
        compete: "",
        control: "",
      },
    };
  },
  computed: {
    valueAndTraitsModalData(): any {
      const analytics = this.$store.getters["assessment/analytics"] || {};
      let result = {};
      const isValuesSelected = this.valueAndTraitsSelected == "Values";
      if (isValuesSelected) {
        if (
          analytics.values_and_traits &&
          analytics.values_and_traits.defining_your_values
        ) {
          result = analytics.values_and_traits.defining_your_values;
        }
      } else {
        if (
          analytics.values_and_traits &&
          analytics.values_and_traits.identifying_key_traits
        ) {
          result = analytics.values_and_traits.identifying_key_traits;
        }
      }
      return result;
    },
    acceptableData(): any[] {
      const analytics = this.$store.getters["assessment/analytics"] || {};
      return _.get(analytics, "acceptable_behaviors") || [];
    },
    radarChartCandidateData(): any[] {
      const analytics = this.$store.getters["assessment/analytics"] || {};
      let items: any[] = [];
      if (Object.prototype.hasOwnProperty.call(analytics, "oaic_archetypes")) {
        const summary = analytics.oaic_archetypes || {};
        if (this.cultureProfileSelected && this.cultureProfileSelected.id) {
          const id = this.cultureProfileSelected.id;
          const rows = summary[id] || [];
          // const colors = ["#30CCB4", "#9CCC30", "#2AEAF2", "#C452F7"];
          const colors = this.avialableColors;
          for (let i = 0; i < rows.length; i++) {
            const idx = i % colors.length;
            const borderColor = colors[idx];
            let item = {
              name: rows[i].user.displayName,
              id: rows[i].user.id,
              data: rows[i].dataset,
              score: rows[i].score,
              pointStyle: "line",
              color: borderColor,
            };
            if (i === 0) {
              item = {
                ...item,
                ...{ color: this.companyColor, borderDash: [3, 1] },
              };
            }
            items.push(item);
          }
        }

        // daatsets.push({
        //   label: "Company Name",
        //   data: this.radarChartCompanyData,
        //   pointStyle: "line",
        //   borderColor: this.companyColor,
        //   borderDash: [3, 1],
        // });
        // for (let i = 0; i < this.radarChartCandidateData.length; i++) {
        //   daatsets.push({
        //     label: this.radarChartCandidateData[i].name,
        //     data: this.radarChartCandidateData[i].data,
        //     pointStyle: "line",
        //     borderColor: this.radarChartCandidateData[i].color,
        //   });
      }
      return items;
    },
    radarChartHumanSkillsCandidateData(): any[] {
      const analytics = this.$store.getters["assessment/analytics"] || {};
      let items: any[] = [];
      if (Object.prototype.hasOwnProperty.call(analytics, "human_skills")) {
        const summary = analytics.human_skills || {};
        if (this.humanSkillsSelected && this.humanSkillsSelected.id) {
          const id = this.humanSkillsSelected.id;
          const rows = summary[id] || [];
          const colors = this.avialableColors;
          for (let i = 0; i < rows.length; i++) {
            const idx = i % colors.length;
            const borderColor = colors[idx];
            let item = {
              name: rows[i].user.displayName,
              id: rows[i].user.id,
              data: rows[i].dataset,
              score: rows[i].score,
              pointStyle: "line",
              color: borderColor,
            };
            if (i === 0) {
              item = {
                ...item,
                ...{ color: this.companyColor, borderDash: [3, 1] },
              };
            }
            items.push(item);
          }
        }
      }
      return items;
    },
    companyName(): string {
      if (this.radarChartCandidateData && this.radarChartCandidateData.length) {
        return this.radarChartCandidateData[0].name;
      }
      return "";
    },
    publicLink(): string {
      const formTemplate = this.$store.getters["assessment/formTemplate"] || {};
      const baseUrl = `${window.location.protocol}//${window.location.host}`;
      const routerPath = "assessment-test";
      // @see src\views\AssessmentTest.vue
      const publicLink = `${baseUrl}/${routerPath}/${formTemplate.routeId}`;
      return publicLink;
    },
    privateLink(): string {
      // return "happily.ai/company/a8dnr55555";
      // assessment-test

      // @todo validate form
      const email = this.form.email.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );

      if (!email || !this.form.firstname || !this.form.lastname) {
        return "";
      }

      const id = this.$router.currentRoute.value.query.id;
      const baseUrl = `${window.location.protocol}//${window.location.host}`;
      const routerPath = "assessment-test";

      const parmas = new URLSearchParams();
      parmas.set("email", this.form.email);
      parmas.set("firstname", this.form.firstname);
      parmas.set("lastname", this.form.lastname);
      const uuid = btoa(encodeURIComponent(parmas.toString()));

      // @see src\views\AssessmentTest.vue
      const privateUrl = `${baseUrl}/${routerPath}/${id}/${uuid}`;
      return privateUrl;
    },
    cadidateData() {
      return this.$store.getters["assessment/candidates"];
    },
    data() {
      return this.$store.getters["assessment/data"];
    },
    formTemplate() {
      return this.$store.getters["assessment/formTemplate"];
    },
    sections() {
      const formTemplate = this.$store.getters["assessment/formTemplate"] || {};
      const sections = formTemplate.sections || [];
      return sections.length;
    },
    extratime() {
      const formTemplate = this.$store.getters["assessment/formTemplate"] || {};
      const extratime = Number(formTemplate.extra_time) || 0;
      const sections = formTemplate.sections || [];
      return extratime * sections.length;
    },
    sectionTimeTotal() {
      const formTemplate = this.$store.getters["assessment/formTemplate"] || {};
      const sections = formTemplate.sections || [];
      const extratime =
        (Number(formTemplate.extra_time) || 0) * sections.length;
      let sectionTimeTotal = sections.length * 5 + extratime;

      if (sections.indexOf("human_skills") != -1) {
        sectionTimeTotal += 5;
      }

      return sectionTimeTotal;
    },
    loading() {
      return (
        this.$store.getters["assessment/loading"] ||
        this.$store.getters["assessmentTemplate/loading"]
      );
    },
    companyColor() {
      const defaultCompanyColor = "#000000";
      const user = this.$store.getters["user/user"];
      if (user && user.color) {
        return user.color;
      }
      return defaultCompanyColor;
    },
    scoreSummaryLineData() {
      const candidate = this.$store.getters["assessment/candidates"];
      let itemsSummarycandidate: any[] = [];
      for (const i in candidate) {
        if (candidate[i].status == "COMPLETED") {
          let colorScore = this.checkScoreColor(candidate[i].score);
          const objects = {
            name: candidate[i].display_name,
            percentageOfBar: candidate[i].score,
            value: candidate[i].score,
            color: colorScore,
          };
          itemsSummarycandidate.push(objects);
        }
      }
      return itemsSummarycandidate;
    },
    valueAndTraitsLineData() {
      const candidate = this.$store.getters["assessment/candidates"];
      let itemsSummarycandidate: any[] = [];
      for (const i in candidate) {
        if (candidate[i].status == "COMPLETED") {
          let summaries = _.get(candidate[i], "summaries.values_and_traits");
          if (summaries) {
            let colorScore = this.checkScoreColor(summaries.overall);
            const objects = {
              name: candidate[i].display_name,
              percentageOfBar: summaries.overall,
              value: summaries.overall,
              color: colorScore,
            };
            itemsSummarycandidate.push(objects);
          }
        }
      }
      return itemsSummarycandidate;
    },
    valueAndTraitsDataDetail() {
      const candidate = this.$store.getters["assessment/candidates"];
      let itemsSummarycandidate: any[] = [];
      let itemCalculatorValue: any[] = [];
      let itemCalculatorTraits: any[] = [];
      let summaries = [];
      let resultValue = 0;
      let resultTraits = 0;
      let colorScore = "";
      for (const i in candidate) {
        if (candidate[i].status == "COMPLETED") {
          if (!candidate[i].summaries) continue;
          summaries = _.get(candidate[i], "summaries.values_and_traits");
          if (summaries) {
            itemCalculatorValue.push(summaries.defining_your_values);
            resultValue =
              _.sum(itemCalculatorValue) / itemCalculatorValue.length;
            itemCalculatorTraits.push(summaries.identifying_key_traits);
            resultTraits =
              _.sum(itemCalculatorTraits) / itemCalculatorTraits.length;
            colorScore = this.checkScoreColor(summaries.overall);
          }
        }
      }
      itemsSummarycandidate = [
        {
          label: "Values",
          value: Math.round(resultValue),
          color: colorScore,
        },
        {
          label: "Traits",
          value: Math.round(resultTraits),
          color: colorScore,
        },
      ];

      return itemsSummarycandidate;
    },
    cultureProfileLineData() {
      const candidate = this.$store.getters["assessment/candidates"];
      let itemsSummarycandidate: any[] = [];
      for (const i in candidate) {
        if (candidate[i].status == "COMPLETED") {
          let colorScore = "";
          if (!candidate[i].summaries) continue;
          let summaries = _.get(candidate[i], "summaries.oaic_archetypes");
          if (summaries) {
            colorScore = this.checkScoreColor(summaries.overall);
            const objects = {
              name: candidate[i].display_name,
              percentageOfBar: summaries.overall,
              value: summaries.overall,
              color: colorScore,
            };
            itemsSummarycandidate.push(objects);
          }
        }
      }
      return itemsSummarycandidate;
    },
    cultureProfileDataDetail() {
      const candidate = this.$store.getters["assessment/candidates"];
      let itemsSummarycandidate: any[] = [];
      let itemsDominant: any[] = [];
      let itemsOrganiztionGlue: any[] = [];
      let itemsOrganiztionLeader: any[] = [];
      let itemsStrategic: any[] = [];
      let itemsManagement: any[] = [];
      let itemsCriteria: any[] = [];
      let summaries = [];
      let resultDominant,
        resultOrganiztionGlue,
        resultOrganiztionLeader,
        resultStrategic,
        resultManagement,
        resultCriteria = 0;
      let colorScoreD,
        colorScoreOG,
        colorScoreOL,
        colorScoreS,
        colorScoreM,
        colorScoreC = "";
      for (const i in candidate) {
        if (candidate[i].status == "COMPLETED") {
          summaries = _.get(candidate[i], "summaries.oaic_archetypes");
          if (summaries) {
            itemsDominant.push(summaries.diff.dominant_characteristics);
            itemsOrganiztionGlue.push(summaries.diff.organization_glue);
            itemsOrganiztionLeader.push(
              summaries.diff.organizational_leadership
            );
            itemsStrategic.push(summaries.diff.strategic_emphases);
            itemsManagement.push(summaries.diff.management_of_employees);
            itemsCriteria.push(summaries.diff.criteria_of_success);

            resultDominant = _.sum(itemsDominant) / itemsDominant.length;
            resultOrganiztionGlue =
              _.sum(itemsOrganiztionGlue) / itemsOrganiztionGlue.length;
            resultOrganiztionLeader =
              _.sum(itemsOrganiztionLeader) / itemsOrganiztionLeader.length;
            resultStrategic = _.sum(itemsStrategic) / itemsStrategic.length;
            resultManagement = _.sum(itemsManagement) / itemsManagement.length;
            resultCriteria = _.sum(itemsCriteria) / itemsCriteria.length;
            colorScoreD = this.checkScoreColor(resultDominant);
            colorScoreOG = this.checkScoreColor(resultOrganiztionGlue);
            colorScoreOL = this.checkScoreColor(resultOrganiztionLeader);
            colorScoreS = this.checkScoreColor(resultStrategic);
            colorScoreM = this.checkScoreColor(resultManagement);
            colorScoreC = this.checkScoreColor(resultCriteria);
          }
        }
      }

      const oaicArchetypes =
        this.$store.getters["assessmentSection/oaicArchetypes"] || {};

      // @see src\store\modules\assessment.ts
      // transformOaicArchetypes(), tooltipOncultureLabel
      const locale = "en";
      const translate = (obj: any, attr: string, lang: string) => {
        // @note hold all this issue waiting all translation
        // const lang = (this as any).$i18n.getLocale(0) || "en";
        let label = "";
        if (_.isObject(obj)) {
          if (lang != "en") {
            attr = attr + "_" + lang;
          }
          if (Object.prototype.hasOwnProperty.call(obj, attr)) {
            label = (obj as any)[attr];
          }
        }
        return label;
      };
      const getTooltip = (name: string) => {
        const path = "scenarios." + _.camelCase(name);
        const scenario = _.get(oaicArchetypes, path);
        let tooltipOncultureLabel = {
          collaborate: "",
          create: "",
          compete: "",
          control: "",
        };
        if (scenario && scenario.questions) {
          tooltipOncultureLabel = {
            collaborate: _.filter(scenario.questions, {
              profile: "clan",
            }).map((v) => translate(v, "admin_title", locale))[0],
            create: _.filter(scenario.questions, {
              profile: "create",
            }).map((v) => translate(v, "admin_title", locale))[0],
            compete: _.filter(scenario.questions, {
              profile: "complete",
            }).map((v) => translate(v, "admin_title", locale))[0],
            control: _.filter(scenario.questions, {
              profile: "control",
            }).map((v) => translate(v, "admin_title", locale))[0],
          };
        }
        return {
          tooltipOncultureLabelPrefix: scenario
            ? scenario.admin_description
            : "",
          tooltipOncultureLabel: tooltipOncultureLabel,
        };
      };

      itemsSummarycandidate = [
        {
          id: "dominant_characteristics",
          label: "Dominant Characteristics",
          value: Math.round(Number(resultDominant)) || 0,
          color: colorScoreD,
          tooltip: getTooltip("dominant_characteristics"),
        },
        {
          id: "organization_glue",
          label: "Organizational Glue",
          value: Math.round(Number(resultOrganiztionGlue)) || 0,
          color: colorScoreOG,
          tooltip: getTooltip("organization_glue"),
        },
        {
          id: "organizational_leadership",
          label: "Organizational Leadership",
          value: Math.round(Number(resultOrganiztionLeader)) || 0,
          color: colorScoreOL,
          tooltip: getTooltip("organizational_leadership"),
        },
        {
          id: "strategic_emphases",
          label: "Strategic Emphases",
          value: Math.round(Number(resultStrategic)) || 0,
          color: colorScoreS,
          tooltip: getTooltip("strategic_emphases"),
        },
        {
          id: "management_of_employees",
          label: "Management of Employees",
          value: Math.round(Number(resultManagement)) || 0,
          color: colorScoreM,
          tooltip: getTooltip("management_of_employees"),
        },
        {
          id: "criteria_of_success",
          label: "Criteria of Success",
          value: Math.round(Number(resultCriteria)) || 0,
          color: colorScoreC,
          tooltip: getTooltip("criteria_of_success"),
        },
      ];
      return itemsSummarycandidate;
    },
    humanSkillsLineData() {
      const candidate = this.$store.getters["assessment/candidates"];
      let itemsSummarycandidate: any[] = [];
      for (const i in candidate) {
        if (candidate[i].status == "COMPLETED") {
          let colorScore = "";
          if (!candidate[i].summaries) continue;
          let summaries = _.get(candidate[i], "summaries.human_skills");
          if (summaries) {
            colorScore = this.checkScoreColor(summaries.overall);
            const objects = {
              name: candidate[i].display_name,
              percentageOfBar: summaries.overall,
              value: summaries.overall,
              color: colorScore,
            };
            itemsSummarycandidate.push(objects);
          }
        }
      }
      return itemsSummarycandidate;
    },
    humanSkillsDataDetail() {
      const candidate = this.$store.getters["assessment/candidates"];
      let itemsSummarycandidate: any[] = [];
      let summaries = [];

      const result: any = {};
      let total = 0;
      for (const i in candidate) {
        if (candidate[i].status == "COMPLETED") {
          summaries = _.get(
            candidate[i],
            "summaries.human_skills.human_skills"
          );
          if (!summaries) continue;
          for (const j in summaries) {
            if (!result[j]) {
              result[j] = {
                score: 0,
              };
            }
            result[j].score += Number(summaries[j].score || 0);
          }
          total++;
        }
      }

      for (const i in result) {
        result[i].score = total ? result[i].score / total : 0;
        result[i].color = this.checkScoreColor(result[i].score);
      }

      itemsSummarycandidate = [
        {
          id: "written_communication",
          label: "Written Communication",
          value: Math.round(Number(result.written_communication.score)) || 0,
          color: result.written_communication.color,
          tooltip: "",
        },
        {
          id: "empathy",
          label: "Empathy",
          value: Math.round(Number(result.empathy.score)) || 0,
          color: result.empathy.color,
          tooltip: "",
        },
        {
          id: "situational_awareness",
          label: "Situational Awareness",
          value: Math.round(Number(result.situational_awareness.score)) || 0,
          color: result.situational_awareness.color,
          tooltip: "",
        },
        {
          id: "critical_thinking",
          label: "Critical Thinking",
          value: Math.round(Number(result.critical_thinking.score)) || 0,
          color: result.critical_thinking.color,
          tooltip: "",
        },
      ];
      return itemsSummarycandidate;
    },
    acceptableBehaviorsLineData() {
      const candidate = this.$store.getters["assessment/candidates"];
      let itemsSummarycandidate: any[] = [];
      for (const i in candidate) {
        if (candidate[i].status == "COMPLETED") {
          let colorScore = "";
          if (!candidate[i].summaries) continue;
          let summaries = _.get(candidate[i], "summaries.acceptable_behaviors");
          if (summaries) {
            colorScore = this.checkScoreColor(summaries.overall);
            const objects = {
              name: candidate[i].display_name,
              percentageOfBar: summaries.overall,
              value: summaries.overall,
              color: colorScore,
            };
            itemsSummarycandidate.push(objects);
          }
        }
      }
      return itemsSummarycandidate;
    },
    acceptableBehaviorsDataDetail() {
      const candidate = this.$store.getters["assessment/candidates"];
      let itemsSummarycandidate: any[] = [];
      let itemCalculator: any[] = [];
      let summaries = [];
      let result = 0;
      let colorScore = "";
      for (const i in candidate) {
        if (candidate[i].status == "COMPLETED") {
          summaries = _.get(candidate[i], "summaries.acceptable_behaviors");
          if (summaries) {
            itemCalculator.push(summaries.overall);
            result = _.sum(itemCalculator) / itemCalculator.length;
            colorScore = this.checkScoreColor(summaries.overall);
          }
        }
      }
      itemsSummarycandidate = [
        {
          label: "Scenario Alignment",
          value: Math.round(result),
          color: colorScore,
        },
      ];
      return itemsSummarycandidate;
    },
    inviteLineData() {
      const candidate = this.$store.getters["assessment/candidates"];
      let itemsInviteData = 0;
      let percentItem = "";
      for (const i in candidate) {
        if (candidate[i].status == "INVITED") {
          itemsInviteData++;
        }
      }
      if (itemsInviteData != 0) {
        const percentage = candidate.length
          ? Math.round((itemsInviteData / candidate.length) * 100)
          : 0;
        percentItem = "(" + percentage + "%)";
      }
      return itemsInviteData + " " + percentItem;
    },
    startedLineData() {
      const candidate = this.$store.getters["assessment/candidates"];
      let itemsInviteData = 0;
      let percentItem = "";
      for (const i in candidate) {
        if (candidate[i].status == "TODO") {
          itemsInviteData++;
        }
      }
      if (itemsInviteData != 0) {
        const percentage = candidate.length
          ? Math.round((itemsInviteData / candidate.length) * 100)
          : 0;
        percentItem = "(" + percentage + "%)";
      }
      return itemsInviteData + " " + percentItem;
    },
    incompleteLineData() {
      const candidate = this.$store.getters["assessment/candidates"];
      let itemsInviteData = 0;
      let percentItem = "";
      for (const i in candidate) {
        if (candidate[i].status == "IN_PROGRESS") {
          itemsInviteData++;
        }
      }
      if (itemsInviteData != 0) {
        const percentage = candidate.length
          ? Math.round((itemsInviteData / candidate.length) * 100)
          : 0;
        percentItem = "(" + percentage + "%)";
      }
      return itemsInviteData + " " + percentItem;
    },
    completeLineData() {
      const candidate: any[] = this.$store.getters["assessment/candidates"];
      let itemsInviteData = 0;
      let percentItem = "";
      for (const i in candidate) {
        if (candidate[i].status == "COMPLETED") {
          itemsInviteData++;
        }
      }
      if (itemsInviteData != 0) {
        const percentage = candidate.length
          ? Math.round((itemsInviteData / candidate.length) * 100)
          : 0;
        percentItem = "(" + percentage + "%)";
      }
      return itemsInviteData + " " + percentItem;
    },
    progressData() {
      const candidate = this.$store.getters["assessment/candidates"];
      let itemsInviteData = 0;
      let percentItem = 0;
      for (const i in candidate) {
        if (candidate[i].status == "COMPLETED") {
          itemsInviteData++;
        }
      }
      percentItem = (itemsInviteData / candidate.length) * 100;
      return percentItem ? percentItem : 0;
    },
    hasValueAndTraitsLineData() {
      if (!this.valueAndTraitsLineData.length) {
        return false;
      }
      return true;
    },
    hasCultureProfileLineData() {
      if (!this.cultureProfileLineData.length) {
        return false;
      }
      return true;
    },
    hasHumanSkillsLineData() {
      if (!this.humanSkillsLineData.length) {
        return false;
      }
      return true;
    },
    hasAcceptableBehaviorsLineData() {
      if (!this.acceptableBehaviorsLineData.length) {
        return false;
      }
      return true;
    },
    canInvite() {
      return this.$store.getters["quota/canInvite"];
    },
    canSendAdvancedInvite(): boolean {
      return this.checkSendAdvancedInvite();
    },
  },
  watch: {
    // loading(value) {
    //   if (value) {
    //     loadingEl = ElLoading.service({
    //       lock: true,
    //       text: "Login..",
    //       background: "#ffffff90",
    //     });
    //   } else {
    //     if (loadingEl) {
    //       loadingEl.close();
    //     }
    //   }
    // },
    // inputBulkEmail(value) {
    //   this.mutipleBulkEmail = this.mutipleBulkEmail + "," + value;
    // },
    mutipleBulkEmail(value) {
      this.cloneValidateEmail(value);
    },
  },
  mounted() {
    this.checkPropsId();
    this.cloneValidateEmail("");
    this.loadCandidates();
    this.setHight();

    // set mockdata
    this.acceptableMockData = acceptableData;
    this.valueAndTraitsMockData = valueAndTraitsData;

    // @fixed test data
    // const analytics = JSON.parse(
    //   `{"values_and_traits":{"defining_your_values":[{"name":"Most Important - 5","label_en":"Most Important - 5","id":"most_important_5","percentage":0,"value":[],"priority":5},{"name":"Important - 4","label_en":"Important - 4","id":"important_4","percentage":0,"value":[{"name":"Adaptability","label_en":"Adaptability","id":"IvZh8fKnvIXMCpy2ai3a","percentage":100,"candidate":[{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"green","identifying_key_traits":76.19,"defining_your_values":75}]}],"priority":4},{"name":"Neutral - 3","label_en":"Neutral - 3","id":"neutral_3","percentage":0,"value":[{"name":"Efficiency","label_en":"Efficiency","id":"MaWAzpGv0JN2SU9ptWl1","percentage":100,"candidate":[{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"yellow","identifying_key_traits":76.19,"defining_your_values":75}]},{"name":"Balance (work/life)","label_en":"Balance (work/life)","id":"fOGJPFgxV789ZyWjm3V3","percentage":100,"candidate":[{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"yellow","identifying_key_traits":76.19,"defining_your_values":75}]},{"name":"Integrity","label_en":"Integrity","id":"7wDdNRPFGMnaCHrGP9Za","percentage":100,"candidate":[{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"yellow","identifying_key_traits":76.19,"defining_your_values":75}]}],"priority":3},{"name":"Low Importance - 2","label_en":"Low Importance - 2","id":"low_importance_2","percentage":0,"value":[{"name":"Altruism","label_en":"Altruism","id":"Ag5cDhqeDdiOPFjYZS0S","percentage":100,"candidate":[{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"red","identifying_key_traits":76.19,"defining_your_values":75}]},{"name":"Humility","label_en":"Humility","id":"8QgNFh7BBVxx59qFjfoL","percentage":100,"candidate":[{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"red","identifying_key_traits":76.19,"defining_your_values":75}]},{"name":"Fun","label_en":"Fun","id":"B6CjvYv5GNJhzi0jIupE","percentage":100,"candidate":[{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"red","identifying_key_traits":76.19,"defining_your_values":75}]},{"name":"Generosity","label_en":"Generosity","id":"CcF5GOsCpAr27qHtQxpH","percentage":100,"candidate":[{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"red","identifying_key_traits":76.19,"defining_your_values":75}]}],"priority":2},{"name":"Not At All Important - 1","label_en":"Not At All Important - 1","id":"not_at_all_important_1","percentage":0,"value":[],"priority":1}],"identifying_key_traits":[{"name":"Most Important - 5","label_en":"Most Important - 5","id":"most_important_5","percentage":0,"value":[],"priority":5},{"name":"Important - 4","label_en":"Important - 4","id":"important_4","percentage":0,"value":[{"name":"Flexible","label_en":"Flexible","id":"Slm5QbtWMwosufBKR3YZ","percentage":100,"candidate":[{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"green","identifying_key_traits":76.19,"defining_your_values":75}]},{"name":"Ambitious","label_en":"Ambitious","id":"95O5FAdcQY15YuUkSTbL","percentage":100,"candidate":[{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"green","identifying_key_traits":76.19,"defining_your_values":75}]},{"name":"Accountable","label_en":"Accountable","id":"uJ4QywudEoiFBM6FYGJW","percentage":100,"candidate":[{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"green","identifying_key_traits":76.19,"defining_your_values":75}]}],"priority":4},{"name":"Neutral - 3","label_en":"Neutral - 3","id":"neutral_3","percentage":0,"value":[{"name":"Loyal","label_en":"Loyal","id":"yRnjJTVrKIUpJRGTzk1C","percentage":100,"candidate":[{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"yellow","identifying_key_traits":76.19,"defining_your_values":75}]},{"name":"Fair","label_en":"Fair","id":"SidNzXXDo48WEAq40j0W","percentage":100,"candidate":[{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"yellow","identifying_key_traits":76.19,"defining_your_values":75}]},{"name":"Accessible","label_en":"Accessible","id":"FYQPRKOIqFcE2d2gAFSL","percentage":100,"candidate":[{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"yellow","identifying_key_traits":76.19,"defining_your_values":75}]},{"name":"Fun-loving","label_en":"Fun-loving","id":"pOjuCAmBtyzHmZGeisvJ","percentage":100,"candidate":[{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"yellow","identifying_key_traits":76.19,"defining_your_values":75}]},{"name":"Honest","label_en":"Honest","id":"WYFMxttufFIpqntUdsjM","percentage":100,"candidate":[{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"yellow","identifying_key_traits":76.19,"defining_your_values":75}]},{"name":"Friendly","label_en":"Friendly","id":"ZIHcKrRow6EYJwsObqsT","percentage":100,"candidate":[{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"yellow","identifying_key_traits":76.19,"defining_your_values":75}]}],"priority":3},{"name":"Low Importance - 2","label_en":"Low Importance - 2","id":"low_importance_2","percentage":0,"value":[{"name":"Benevolent","label_en":"Benevolent","id":"4HnfEB6awExrBr86NI54","percentage":100,"candidate":[{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"red","identifying_key_traits":76.19,"defining_your_values":75}]}],"priority":2},{"name":"Not At All Important - 1","label_en":"Not At All Important - 1","id":"not_at_all_important_1","percentage":0,"value":[],"priority":1}]},"oaic_archetypes":{"criteria_of_success":[{"user":{"id":"company_criteria_of_success","name":"SARIYER BLD.","displayName":"SARIYER BLD."},"dataset":[20,40,20,20],"score":9999},{"user":{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"","identifying_key_traits":76.19,"defining_your_values":75},"dataset":[100,0,0,0],"score":20}],"dominant_characteristics":[{"user":{"id":"company_dominant_characteristics","name":"SARIYER BLD.","displayName":"SARIYER BLD."},"dataset":[20,40,20,20],"score":9999},{"user":{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"","identifying_key_traits":76.19,"defining_your_values":75},"dataset":[100,0,0,0],"score":20}],"management_of_employees":[{"user":{"id":"company_management_of_employees","name":"SARIYER BLD.","displayName":"SARIYER BLD."},"dataset":[20,40,20,20],"score":9999},{"user":{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"","identifying_key_traits":76.19,"defining_your_values":75},"dataset":[0,100,0,0],"score":40}],"organization_glue":[{"user":{"id":"company_organization_glue","name":"SARIYER BLD.","displayName":"SARIYER BLD."},"dataset":[20,40,20,20],"score":9999},{"user":{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"","identifying_key_traits":76.19,"defining_your_values":75},"dataset":[0,0,100,0],"score":20}],"organizational_leadership":[{"user":{"id":"company_organizational_leadership","name":"SARIYER BLD.","displayName":"SARIYER BLD."},"dataset":[20,40,20,20],"score":9999},{"user":{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"","identifying_key_traits":76.19,"defining_your_values":75},"dataset":[0,100,0,0],"score":40}],"strategic_emphases":[{"user":{"id":"company_strategic_emphases","name":"SARIYER BLD.","displayName":"SARIYER BLD."},"dataset":[20,40,20,20],"score":9999},{"user":{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"","identifying_key_traits":76.19,"defining_your_values":75},"dataset":[0,0,0,100],"score":20}]},"human_skills":{"critical_thinking":[{"user":{"id":"company_critical_thinking","name":"SARIYER BLD.","displayName":"SARIYER BLD."},"dataset":[100,100,100,100],"score":9999},{"user":{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"","identifying_key_traits":76.19,"defining_your_values":75},"dataset":[60,65,70,50],"score":70}],"empathy":[{"user":{"id":"company_empathy","name":"SARIYER BLD.","displayName":"SARIYER BLD."},"dataset":[100,100,100,100],"score":9999},{"user":{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"","identifying_key_traits":76.19,"defining_your_values":75},"dataset":[60,65,70,50],"score":50}],"situational_awareness":[{"user":{"id":"company_situational_awareness","name":"SARIYER BLD.","displayName":"SARIYER BLD."},"dataset":[100,100,100,100],"score":9999},{"user":{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"","identifying_key_traits":76.19,"defining_your_values":75},"dataset":[60,65,70,50],"score":65}],"written_communication":[{"user":{"id":"company_written_communication","name":"SARIYER BLD.","displayName":"SARIYER BLD."},"dataset":[100,100,100,100],"score":9999},{"user":{"displayName":"rrrr","name":"rrrr","id":"2uRsiQMdqVIMAdzmdWXb-rathasit_j@dhas||com","color":"","identifying_key_traits":76.19,"defining_your_values":75},"dataset":[60,65,70,50],"score":60}]},"acceptable_behaviors":[{"name":"","question":"Taking credit for someone else's work.","valuePercentage":0,"candidateValue":[{"displayName":"rrrr","value":"3","score":33.33333333333333}],"companyValue":3,"companyValueLabel":"Reprimanded","companyValueColor":"yellow"},{"name":"","question":"Not confronting others when they're not acting according to our core values.","valuePercentage":0,"candidateValue":[{"displayName":"rrrr","value":"3","score":33.33333333333333}],"companyValue":3,"companyValueLabel":"Reprimanded","companyValueColor":"yellow"},{"name":"","question":"Taking the day off without any explanation and no prior notice.","valuePercentage":0,"candidateValue":[{"displayName":"rrrr","value":"3","score":33.33333333333333}],"companyValue":3,"companyValueLabel":"Reprimanded","companyValueColor":"yellow"},{"name":"","question":"Using headphones and listening to music while working.","valuePercentage":0,"candidateValue":[{"displayName":"rrrr","value":"3","score":33.33333333333333}],"companyValue":4,"companyValueLabel":"Zero Tolerance Policy","companyValueColor":"red"},{"name":"","question":"Confronting others when they're not acting according to our core values.","valuePercentage":0,"candidateValue":[{"displayName":"rrrr","value":"3","score":33.33333333333333}],"companyValue":4,"companyValueLabel":"Zero Tolerance Policy","companyValueColor":"red"},{"name":"","question":"Not answering any emails or calls on the weekends.","valuePercentage":0,"candidateValue":[{"displayName":"rrrr","value":"3","score":33.33333333333333}],"companyValue":4,"companyValueLabel":"Zero Tolerance Policy","companyValueColor":"red"},{"name":"","question":"Submitting work late without any warning and communication.","valuePercentage":0,"candidateValue":[{"displayName":"rrrr","value":"3","score":33.33333333333333}],"companyValue":0,"companyValueLabel":"Acceptable","companyValueColor":"green"},{"name":"","question":"Using work hours to run personal errands if okay'd by your manager.","valuePercentage":0,"candidateValue":[{"displayName":"rrrr","value":"3","score":33.33333333333333}],"companyValue":0,"companyValueLabel":"Acceptable","companyValueColor":"green"},{"name":"","question":"Unresponsive over chat for most of the day with a clear away status.","valuePercentage":100,"candidateValue":[{"displayName":"rrrr","value":"2","score":33.33333333333333}],"companyValue":2,"companyValueLabel":"Actively Discouraged","companyValueColor":"yellow"},{"name":"","question":"Respectfully disagreeing with your manager or colleague over a decision.","valuePercentage":100,"candidateValue":[{"displayName":"rrrr","value":"2","score":33.33333333333333}],"companyValue":2,"companyValueLabel":"Actively Discouraged","companyValueColor":"yellow"},{"name":"","question":"Not answering any urgent emails or calls on the weekends.","valuePercentage":100,"candidateValue":[{"displayName":"rrrr","value":"2","score":33.33333333333333}],"companyValue":2,"companyValueLabel":"Actively Discouraged","companyValueColor":"yellow"},{"name":"","question":"Using work hours to run personal errands.","valuePercentage":100,"candidateValue":[{"displayName":"rrrr","value":"1","score":33.33333333333333}],"companyValue":1,"companyValueLabel":"Frowned Upon","companyValueColor":"yellow"},{"name":"","question":"Unresponsive over chat for most of the day without an away status.","valuePercentage":100,"candidateValue":[{"displayName":"rrrr","value":"2","score":33.33333333333333}],"companyValue":2,"companyValueLabel":"Actively Discouraged","companyValueColor":"yellow"},{"name":"","question":"Taking the day off without any explanation with a few days' notice.","valuePercentage":100,"candidateValue":[{"displayName":"rrrr","value":"1","score":33.33333333333333}],"companyValue":1,"companyValueLabel":"Frowned Upon","companyValueColor":"yellow"},{"name":"","question":"Frequently showing up a couple of minutes late to meetings and appointments.","valuePercentage":100,"candidateValue":[{"displayName":"rrrr","value":"2","score":33.33333333333333}],"companyValue":2,"companyValueLabel":"Actively Discouraged","companyValueColor":"yellow"}]}`
    // );
    // this.$store.commit("assessment/analytics", analytics, { root: true });
    // this.analyticsLoadedStatus = true;

    setTimeout(() => {
      const formTemplate = this.$store.getters["assessment/formTemplate"] || {};
      let content = this.getDefaultInviteHtmlBody();
      if (formTemplate && formTemplate.advancedInviteEmailTemplate) {
        const advancedInviteEmailTemplate =
          formTemplate.advancedInviteEmailTemplate;
        if (advancedInviteEmailTemplate.htmlBody) {
          content = advancedInviteEmailTemplate.htmlBody;
          this.advancedForm.subject = advancedInviteEmailTemplate.subject;
          this.advancedForm.emailSender = advancedInviteEmailTemplate.sender;
        }
      }
      (this.advancedForm as any).emailBody = new Editor({
        // content: `
        //   <p>Hi $RECIPIENT_FIRST_NAME</p>
        //   <p>$SENDER_FIRST_NAME $SENDER_LAST_NAME from Happily.ai (test) has invited you to take a Culture Assessment. This assessment has the following sections:</p>
        //   <p>1. Human Skills</p>
        //   <p>2. Work Style Identifier</p>
        //   <p>We recommend that you take this assessment when you have 15 minutes.</p>
        //   <p>$BUTTON_TO_ASSESSMENT</p>
        //   <p>If you have any questions or concerns, please feel free to reach out to us at support@happily.ai anytime!</p>
        //   <p>Happily yours,</p>
        //   <p>The Happily Team</p>
        // `,
        content: content,
        extensions: [StarterKit],
      });
    }, 3000);
  },
  methods: {
    onEnter() {
      this.mutipleBulkEmail = this.mutipleBulkEmail + " " + this.inputBulkEmail;
      this.inputBulkEmail = "";
    },
    removeEmailBulked(index: number, email: string) {
      this.mutipleBulkValidteEmail.splice(index, 1);
      this.mutipleBulkEmail = this.mutipleBulkEmail.replace(email, "");
    },
    checkCanInvite() {
      if (!this.canInvite) {
        // show error message can't invite
        ElMessage.error((this as any).$t("popup.message.message_9e"));
        return false;
      }
      return true;
    },
    openInviteBulkEmailModal() {
      if (!this.checkCanInvite()) return;
      this.bulkModalStatus = true;
    },
    openAdvancedInviteSenderModal() {
      this.advancedInviteStatus = true;
    },
    closeAdvancedInviteSenderModal() {
      this.advancedInviteStatus = false;
    },
    getDefaultInviteHtmlBody() {
      // @see cloud function: sendEmailToCandidateInviteWeb
      // console.log("getInviteHtmlBody()");
      const formTemplate = this.$store.getters["assessment/formTemplate"] || {};
      const user = this.$store.getters["user/user"] || {};
      // console.log(formTemplate, "formTemplate");

      // {==SECTIONS_TO_SETUP==}
      const sections = formTemplate.sections || [];
      sections.sort((a: string, b: string) => {
        a = a.toLowerCase();
        b = b.toLowerCase();
        const indexMap = {
          values_and_traits: 1,
          oaic_archetypes: 2,
          human_skills: 3,
          acceptable_behaviors: 4,
          work_style_identifier: 5,
        };
        type keys = keyof typeof indexMap;
        const keyA = a as keys;
        const keyB = b as keys;
        const $a = indexMap[keyA];
        const $b = indexMap[keyB];
        return $a - $b;
      });
      // console.log(sections, "sections");

      let SECTIONS_TO_SETUP = "<ol>";
      for (let i = 0; i < sections.length; i++) {
        const sectionName = sections[i].toLowerCase();
        switch (sectionName) {
          case "values_and_traits":
            SECTIONS_TO_SETUP +=
              // "<p>" + (i + 1).toString() + ". Values & Traits</p>";
              "<li>Values & Traits</li>";
            break;
          case "oaic_archetypes":
            SECTIONS_TO_SETUP +=
              // "<p>" + (i + 1).toString() + ". Culture Profile</p>";
              "<li>Culture Profile</li>";
            break;
          case "human_skills":
            SECTIONS_TO_SETUP +=
              // "<p>" + (i + 1).toString() + ". Human Skills</p>";
              "<li>Human Skills</li>";
            break;
          case "acceptable_behaviors":
            SECTIONS_TO_SETUP +=
              // "<p>" + (i + 1).toString() + ". Acceptable Behaviors</p>";
              "<li>Acceptable Behaviors</li>";
            break;
          case "work_style_identifier":
            SECTIONS_TO_SETUP +=
              // "<p>" + (i + 1).toString() + ". Work Style Identifier</p>";
              "<li>Work Style Identifier</li>";
            break;
        }
      }
      SECTIONS_TO_SETUP += "</ol>";

      let sectionTime = 5;
      const extraTime: number = formTemplate.extra_time || 0;
      sectionTime += extraTime;

      let TOTAL_MINUTES = sections.length * sectionTime;
      // console.log(TOTAL_MINUTES, "TOTAL_MINUTES");

      // Human Skills use 10 minutes NOT 5 minutes
      if (_.indexOf(sections, "human_skills") !== -1) {
        TOTAL_MINUTES += 5;
      }

      const firstname = user.firstName || "";
      const lastname = user.lastName || "";
      let senderName = firstname;
      if (lastname.length) {
        senderName += " " + lastname;
      }

      const htmlBody = `
      <h2>Hi $RECIPIENT_FIRST_NAME</h2>
      <p>${senderName} from ${user.companyName} has invited you to take a Culture Assessment. This assessment has the following sections:</p>

      ${SECTIONS_TO_SETUP}

      <p>We recommend that you take this assessment when you have ${TOTAL_MINUTES} minutes.</p>
      <br />
      <p>$BUTTON_TO_ASSESSMENT</p>
      <br />
      <p>If you have any questions or concerns, please feel free to reach out to us at support@happily.ai anytime!<br class="ProseMirror-trailingBreak" /></p>
      <p>Happily yours,<br class="ProseMirror-trailingBreak" /></p>
      <p>The MyCulture Team</p>
`;
      return htmlBody;
    },
    async inviteBulkEmail() {
      // console.log("inviteBulkEmail()");
      if (!this.mutipleBulkValidteEmail.length) return;

      const MAX_EMAILS_TO_INVITE = 50;
      const emails = _.uniq(this.mutipleBulkValidteEmail);
      if (emails.length > MAX_EMAILS_TO_INVITE) {
        const errorMsg =
          (this as any).$t("popup.message.message_9e") + MAX_EMAILS_TO_INVITE;
        ElMessage.error(errorMsg);
        return;
      }

      const curretFormValues = {
        email: this.form.email,
        firstname: this.form.firstname,
        lastname: this.form.lastname,
      };
      this.inviteBulkButtonLoading = true;
      for (const i in emails) {
        const email = this.mutipleBulkValidteEmail[i];
        // used for _invite() method
        this.form.email = email;
        this.form.firstname = "";
        this.form.lastname = "";
        await this._invite();
      }
      this.inviteBulkButtonLoading = false;

      // restore previous values
      this.form.email = curretFormValues.email;
      this.form.firstname = curretFormValues.firstname;
      this.form.lastname = curretFormValues.lastname;

      ElMessage({
        message: (this as any).$t("popup.message.message_11"),
        type: "success",
      });
      this.mutipleBulkEmail = "";
      this.bulkModalStatus = false;
      this.loadCandidates();
    },
    checkScoreColor(data: any) {
      let color = "";
      if (data < 60) {
        color = "red";
      } else if (data < 80) {
        color = "yellow";
      } else if (data >= 80) {
        color = "green";
      }
      return color;
    },
    cloneValidateEmail(emailArr: any) {
      const comma = emailArr.split(/, | /);
      this.mutipleBulkValidteEmail = [];
      if (comma.length > 0) {
        for (let i = 0; i < comma.length; i++) {
          if (comma[i].trim()) {
            const emailValidate = comma[i]
              .trim()
              .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              );
            if (emailValidate) {
              this.mutipleBulkValidteEmail.push(comma[i].trim());
            }
          }
        }
      }
      this.mutipleBulkValidteEmail = _.uniq(this.mutipleBulkValidteEmail);
    },
    async loadCandidates() {
      const formId = this.$router.currentRoute.value.query.id;
      await this.$store.dispatch(
        "assessment/getCandidates",
        { formId: formId },
        { root: true }
      );
      const formTemplate = this.$store.getters["assessment/formTemplate"];
      if (_.isObject(formTemplate)) {
        this.setHight();
      }
    },
    editForm() {
      const routeId = this.formTemplate.routeId;
      this.$router.replace(`/assessment/edit/${routeId}`);
    },
    async handleCommand(command: string, row: any) {
      switch (command) {
        case "edit":
          break;
        case "delete":
          ElMessageBox.confirm(
            (this as any).$t("popup.question.question_box_3.question"),
            (this as any).$t("popup.question.question_box_3.title"),
            {
              confirmButtonText: (this as any).$t("popup.optional.Yes_chi"),
              cancelButtonText: (this as any).$t("popup.optional.Cancel"),
              type: "warning",
            }
          )
            .then(async () => {
              await this.$store.dispatch("assessment/deleteCandidate", row, {
                root: true,
              });
              this.loadCandidates();
            })
            .catch((error) => {
              console.error(error);
            });
          break;
        case "clone":
          break;
      }
    },
    assessmentsCandidate(row: any) {
      if (row.status != "COMPLETED") return;
      const id = row._id;
      this.$router.push({
        name: "AssessmentsCandidate",
        query: {
          as_id: this.assessmentsID,
          u_id: btoa(encodeURIComponent(id)),
        },
      });
    },
    checkPropsId() {
      const id = this.$router.currentRoute.value.query.id;
      if (id) {
        this.assessmentsID = id + "";
      } else {
        ElMessage({
          message: (this as any).$t("popup.message.message_12"),
          type: "warning",
        });
        setTimeout(() => {
          this.$router.push({ name: "Assessments" });
        }, 1000);
      }
    },
    barWidht(progress: number, candidates: number) {
      const pergressPercentage = (progress / candidates) * 100;
      return `width: ${pergressPercentage.toFixed(1)}%`;
    },
    fontColor(progress: number, candidates: number) {
      const pergressPercentage = (progress / candidates) * 100;
      if (+pergressPercentage.toFixed(1) > 50) {
        return true;
      }
      return false;
    },
    copyLink() {
      if (!this.publicLink) return;
      ElMessage({
        message: (this as any).$t("popup.message.message_8"),
        type: "success",
      });
      const clipboardData =
        (window as any).clipboardData || navigator.clipboard;
      clipboardData.writeText(this.publicLink);
    },
    resetInvitationForm() {
      this.form.email = "";
      this.form.firstname = "";
      this.form.lastname = "";
    },
    async _invite(option: { htmlBody?: string } = {}) {
      /* eslint-disable */
      const email = this.form.email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
      /* eslint-enable */
      let validate = true;

      // HTML Body from advanced invitation
      if (!option.htmlBody) {
        this.formValidate.email = false;
        if (!email) {
          this.formValidate.email = true;
          validate = false;
        }
      }
      if (validate) {
        const formId = this.$router.currentRoute.value.query.id;

        // @todo make publicLink for checking link from email and init data
        const formDetailsDto: any = _.merge(
          {
            formId: formId,
            publicUrl: this.publicLink,
            email: this.form.email,
            firstname: this.form.firstname,
            lastname: this.form.lastname,
            sections: Object.values(this.formTemplate.sections),
          },
          option
        );

        await this.$store.dispatch(
          "assessmentTemplate/invite",
          formDetailsDto,
          {
            root: true,
          }
        );
      }
    },
    async invite() {
      if (!this.checkCanInvite()) return;
      /* eslint-disable */
      const email = this.form.email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
      let validate = true;
      if (!email) {
        validate = false;
      }
      if (!validate) return;
      this.inviteButtonLoading = true;
      await this._invite();
      this.inviteButtonLoading = false;
      ElMessage({
        message:
          (this as any).$t("popup.message.message_13_1") +
          // email +
          this.form.email +
          (this as any).$t("popup.message.message_13_2"),
        type: "success",
      });
      this.resetInvitationForm();
      this.loadCandidates();
    },
    format(datetime: string) {
      return helpers.dateFormat(datetime);
    },
    status(status: string) {
      return helpers.workflowStatus(status);
    },
    onClickRating(item: any) {
      // don't neccessary to await
      this.$store.commit("assessment/ignoreLoading", true);
      this.$store.dispatch("assessment/saveRating", item, { root: true });
      this.$store.commit("assessment/ignoreLoading", false);
    },
    setHight() {
      this.inviteExpendHeight = this.$refs.invite_container_ref
        ? (this.$refs.invite_container_ref as any).clientHeight + 30
        : 0;
      this.anlyticsExpendHeight = this.$refs.analytics_container_ref
        ? (this.$refs.analytics_container_ref as any).clientHeight + 30
        : 0;
    },
    async openValuesAndTraitsModalDetail(item?: any) {
      if (this.analyticsLoadingStatus) return;
      this.valueAndTraitsModalStatus = true;
      if (item && item.label) {
        await this.loadAnalytics();
        this.valueAndTraitsSelected = item.label;
      }
    },
    async openChartcultureModalDetail(item?: any) {
      if (this.analyticsLoadingStatus) return;
      // is called by setTimeout (sometime)
      this.cultureProfileModalStatus = !this.cultureProfileModalStatus;
      if (item && item.label) {
        this.cultureProfileSelected = item;
        if (item.tooltip) {
          this.tooltipOncultureStatus = false;
          this.tooltipOncultureLabelPrefix =
            item.tooltip.tooltipOncultureLabelPrefix + " ";
          this.tooltipOncultureLabel = item.tooltip.tooltipOncultureLabel;
        }
      }
      await this.loadAnalytics();
      if (this.cultureProfileModalStatus) {
        if (!this.culturePreferenceRenderChart) {
          this.chartculturePreference();
        } else {
          setTimeout(() => {
            console.log("setTimeout(300)");
            this.openChartcultureModalDetail();
          }, 300);
        }
      }
    },
    async openChartHumanSkillsModalDetail(item?: any) {
      if (this.analyticsLoadingStatus) return;
      // is called by setTimeout (sometime)
      this.humanSkillsModalStatus = !this.humanSkillsModalStatus;
      if (item && item.label) {
        this.humanSkillsSelected = item;
        if (item.tooltip) {
          this.tooltipOncultureStatus = false;
          this.tooltipOncultureLabelPrefix =
            item.tooltip.tooltipOncultureLabelPrefix + " ";
          this.tooltipOncultureLabel = item.tooltip.tooltipOncultureLabel;
        }
      }
      await this.loadAnalytics();
      if (this.humanSkillsModalStatus) {
        if (!this.humanSkillsRenderChart) {
          this.chartHumanSkillsPreference();
        } else {
          setTimeout(() => {
            console.log("setTimeout(310)");
            this.openChartHumanSkillsModalDetail();
          }, 310);
        }
      }
    },
    async openAcceptableBehaviorsDataDetail() {
      if (this.analyticsLoadingStatus) return;
      this.acceptableBehaviorsModalStatus = true;
      await this.loadAnalytics();
    },
    chartculturePreference() {
      this.culturePreferenceRenderChart = true;
      const chartContent = this.$refs.culture_preference_chart;

      if (this.radarChartVal && Object.keys(this.radarChartVal).length) {
        (this.radarChartVal as any).destroy();
      }
      if (chartContent) {
        const ctx = (chartContent as any).getContext("2d");
        const options = {
          elements: {
            line: {
              backgroundColor: "rgba(0, 0, 0, 0)",
              borderWidth: 2,
            },
          },
          scales: {
            r: {
              grid: {
                display: false,
              },
              min: 0,
              ticks: {
                display: false,
                color: "rgba(0, 0, 0, 0)",
                beginAtZero: false,
                stepSize: 10,
                callback: function () {
                  return "";
                },
              },
              pointLabels: {
                color: "#000",
                fontSize: 14,
                font: {
                  size: 14,
                  weight: "700",
                },
              },
              gridLines: {
                lineWidth: 2,
                color: "lightgreen",
                borderDash: (context: any) =>
                  context.index == 6 ? [] : [6, 4],
              },
            },
          },
          plugins: {
            title: {
              display: false,
            },
            legend: {
              display: false,
            },
            tooltip: {
              enabled: false,
            },
          },
        };
        // const user = [
        //   {
        //     name: "jack Smith",
        //     data: [8, 11, 12, 9],
        //     color: "#30CCB4",
        //   },
        //   {
        //     name: "Allen Key",
        //     data: [8, 11, 12, 9],
        //     color: "#9CCC30",
        //   },
        //   {
        //     name: "Barbra Longely",
        //     data: [8, 11, 12, 9],
        //     color: "#2AEAF2",
        //   },
        //   {
        //     name: "Sam Lee",
        //     data: [8, 11, 12, 9],
        //     color: "#C452F7",
        //   },
        // ];

        const daatsets = [];
        // daatsets.push({
        //   label: "Company Name",
        //   data: this.radarChartCompanyData,
        //   pointStyle: "line",
        //   borderColor: this.companyColor,
        //   borderDash: [3, 1],
        // });
        for (let i = 0; i < this.radarChartCandidateData.length; i++) {
          let itemSelceted = true;
          const fillteredID = this.culturePreferenceRenderChartFilter;
          for (let index2 = 0; index2 < fillteredID.length; index2++) {
            if (fillteredID[index2] == this.radarChartCandidateData[i].id) {
              itemSelceted = false;
            }
          }
          if (itemSelceted) {
            let item = {
              label: this.radarChartCandidateData[i].name,
              data: this.radarChartCandidateData[i].data,
              pointStyle: "line",
              borderColor: this.radarChartCandidateData[i].color,
              score: this.radarChartCandidateData[i].score,
            };
            if (i == 0) {
              item = { ...item, ...{ borderDash: [3, 1] } };
            }
            daatsets.push(item);
          }
        }
        // this.radarChartCandidateData.shift();

        this.radarChartVal = new Chart(ctx, {
          type: "radar",
          data: {
            labels: [
              " ",
              " ",
              " ",
              " ",
              // "Collaborate people-oriented",
              // "Create dynamic & entrepreneurial",
              // "Complete result-oriented",
              // "Control process-oriented",
            ],
            datasets: daatsets,
          },
          options: options,
        });
      } else if (this.cultureProfileModalStatus) {
        setTimeout(() => {
          this.chartculturePreference();
        }, 150);
      }
      setTimeout(() => {
        this.culturePreferenceRenderChart = false;
      }, 1000);
    },
    chartHumanSkillsPreference() {
      this.humanSkillsRenderChart = true;
      const chartContent = this.$refs.human_skills_chart;

      if (
        this.humanSkillsRadarChartVal &&
        Object.keys(this.humanSkillsRadarChartVal).length
      ) {
        (this.humanSkillsRadarChartVal as any).destroy();
      }
      if (chartContent) {
        const ctx = (chartContent as any).getContext("2d");
        const options = {
          elements: {
            line: {
              backgroundColor: "rgba(0, 0, 0, 0)",
              borderWidth: 2,
            },
          },
          scales: {
            r: {
              grid: {
                display: false,
              },
              min: 0,
              ticks: {
                display: false,
                color: "rgba(0, 0, 0, 0)",
                beginAtZero: false,
                stepSize: 10,
                callback: function () {
                  return "";
                },
              },
              pointLabels: {
                color: "#000",
                fontSize: 14,
                font: {
                  size: 14,
                  weight: "700",
                },
              },
              gridLines: {
                lineWidth: 2,
                color: "lightgreen",
                borderDash: (context: any) =>
                  context.index == 6 ? [] : [6, 4],
              },
            },
          },
          plugins: {
            title: {
              display: false,
            },
            legend: {
              display: false,
            },
            tooltip: {
              enabled: false,
            },
          },
        };
        const daatsets = [];
        for (
          let i = 0;
          i < this.radarChartHumanSkillsCandidateData.length;
          i++
        ) {
          let itemSelceted = true;
          const fillteredID = this.humanSkillsRenderChartFilter;
          for (let index2 = 0; index2 < fillteredID.length; index2++) {
            if (
              fillteredID[index2] ==
              this.radarChartHumanSkillsCandidateData[i].id
            ) {
              itemSelceted = false;
            }
          }
          if (itemSelceted) {
            let item = {
              label: this.radarChartHumanSkillsCandidateData[i].name,
              data: this.radarChartHumanSkillsCandidateData[i].data,
              pointStyle: "line",
              borderColor: this.radarChartHumanSkillsCandidateData[i].color,
              score: this.radarChartHumanSkillsCandidateData[i].score,
            };
            if (i == 0) {
              item = { ...item, ...{ borderDash: [3, 1] } };
            }
            daatsets.push(item);
          }
        }
        // this.radarChartCandidateData.shift();

        this.humanSkillsRadarChartVal = new Chart(ctx, {
          type: "radar",
          data: {
            labels: [
              " ",
              " ",
              " ",
              " ",
              // "Collaborate people-oriented",
              // "Create dynamic & entrepreneurial",
              // "Complete result-oriented",
              // "Control process-oriented",
            ],
            datasets: daatsets,
          },
          options: options,
        });
      } else if (this.humanSkillsModalStatus) {
        setTimeout(() => {
          this.chartHumanSkillsPreference();
        }, 150);
      }
      setTimeout(() => {
        this.humanSkillsRenderChart = false;
      }, 1000);
    },
    async loadAnalytics(): Promise<any> {
      if (!this.analyticsLoadedStatus) {
        this.analyticsLoadingStatus = true;
        const locale = (this as any).$i18n.getLocale(0) || "en";
        await this.$store.dispatch(
          "assessment/getAnalytics",
          {
            _id: this.assessmentsID,
            locale: locale,
          },
          { root: true }
        );
        this.analyticsLoadingStatus = false;
        this.analyticsLoadedStatus = true;
      }
    },
    actionOnCandidate(value: any) {
      const id = value.id || "";
      if (this.culturePreferenceRenderChartFilter.includes(id)) {
        this.culturePreferenceRenderChartFilter =
          this.culturePreferenceRenderChartFilter.filter((word) => word != id);
      } else {
        this.culturePreferenceRenderChartFilter.push(id);
      }
      if (!this.culturePreferenceRenderChart) {
        if (this.culturePreferenceRenderChartValue > 0) {
          this.culturePreferenceRenderChartValue--;
        }
        this.chartculturePreference();
        setTimeout(() => {
          this.culturePreferenceRenderChartValue = 1;
        }, 1200);
      } else {
        this.culturePreferenceRenderChartValue++;
        setTimeout(() => {
          if (this.culturePreferenceRenderChartValue > 1) {
            this.actionOnCandidate(value);
          }
        }, 400 * this.culturePreferenceRenderChartValue);
      }
    },
    candidateActiveClassOnCulturePreference(id: string) {
      let itemSelceted = true;
      const fillteredID = this.culturePreferenceRenderChartFilter;
      for (let i = 0; i < fillteredID.length; i++) {
        if (fillteredID[i] == id) {
          itemSelceted = false;
        }
      }
      if (itemSelceted) {
        return "";
      } else {
        return "hide";
      }
    },
    candidateActiveClassOnHumanSkillsPreference(id: string) {
      let itemSelceted = true;
      const fillteredID = this.humanSkillsRenderChartFilter;
      for (let i = 0; i < fillteredID.length; i++) {
        if (fillteredID[i] == id) {
          itemSelceted = false;
        }
      }
      if (itemSelceted) {
        return "";
      } else {
        return "hide";
      }
    },
    actionOnHumanSkillsCandidate(value: any) {
      const id = value.id || "";
      if (this.humanSkillsRenderChartFilter.includes(id)) {
        this.humanSkillsRenderChartFilter =
          this.humanSkillsRenderChartFilter.filter((word) => word != id);
      } else {
        this.humanSkillsRenderChartFilter.push(id);
      }
      if (!this.humanSkillsRenderChart) {
        if (this.humanSkillsRenderChartValue > 0) {
          this.humanSkillsRenderChartValue--;
        }
        this.chartHumanSkillsPreference();
        setTimeout(() => {
          this.humanSkillsRenderChartValue = 1;
        }, 1200);
      } else {
        this.humanSkillsRenderChartValue++;
        setTimeout(() => {
          if (this.humanSkillsRenderChartValue > 1) {
            this.actionOnCandidate(value);
          }
        }, 400 * this.humanSkillsRenderChartValue);
      }
    },
    checkSendAdvancedInvite(doNotCheckRecipients = false): boolean {
      if (!doNotCheckRecipients) {
        const recipients = _.clone(this.advancedForm.recipients || []);
        let notFoundEmail = true;
        for (const i in recipients) {
          const recipient = recipients[i];
          if (!recipient) continue;
          const email = recipient.email || "";
          if (email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
            notFoundEmail = false;
          }
        }
        if (notFoundEmail) {
          // console.log("notFoundEmail");
          return false;
        }
      }

      const subject = _.trim(this.advancedForm.subject  || "");
      if (!subject.length) {
        // console.log("!subject.length");
        return false;
      }

      if (this.advancedForm.emailBody) {
        const htmlBody = _.trim((this.advancedForm.emailBody as any).getHTML() || "");
        const removeTags = (str: string) => {
            if ((str===null) || (str===''))
                return false;
            else
                str = str.toString();
                  
            // Regular expression to identify HTML tags in
            // the input string. Replacing the identified
            // HTML tag with a null string.
            return str.replace( /(<([^>]+)>)/ig, '');
        };
        const htmlBodyCheck = String(removeTags(htmlBody));
        if (!htmlBodyCheck.length) {
          // console.log("!htmlBody.length");
          return false;
        }

        if (!htmlBody.match(/\$BUTTON_TO_ASSESSMENT([^a-z])/gi)) {
          // console.log("!$BUTTON_TO_ASSESSMENT");
          return false;
        }
      }

      return true;
    },
    async sendAdvancedInvite() {
      if (!this.checkSendAdvancedInvite()) return false;
      this.removeEmptyValues();
      // console.log("sendAdvancedInvite", this.advancedForm);

      // @todo: validate recipients
      //        First name and Last name are optional but a valid email address is required for each row
      // @see https://trello.com/c/KbKmF0FO/1662-invites-as-a-company-i-want-to-customize-the-invitation-email-so-that-i-can-share-assessments-with-a-personal-welcome-message-wi
      const recipients = _.clone(this.advancedForm.recipients || []);
      if (recipients.length) {
        const option = {
          subject: this.advancedForm.subject,
          sender: this.advancedForm.emailSender,
          htmlBody: (this.advancedForm.emailBody as any).getHTML(),
          recipients: recipients,
        };
        this.inviteBulkButtonLoading = true;
        await this._invite(option);
        this.inviteBulkButtonLoading = false;

        ElMessage({
          message: "Invite email has been sent to candidates",
          type: "success",
        });

        // After call AIP add empty row for next invite
        if (this.advancedForm.recipients.length < 100) {
          this.advancedForm.recipients.push({
            firstname: "",
            lastname: "",
            email: "",
          });
        }

        this.closeAdvancedInviteSenderModal();
        this.loadCandidates();

        // reset recipients
        for (const i in this.advancedForm.recipients) {
          const recipient = recipients[i];
          if (recipient) {
            recipient.firstname = "";
            recipient.lastname = "";
            recipient.email = "";
          }
        }
      }
    },
    async sendTestEmail() {
      if (!this.checkSendAdvancedInvite(true)) return false;

      const user = this.$store.getters["user/user"];
      const option = {
        test: true,
        subject: this.advancedForm.subject,
        sender: this.advancedForm.emailSender,
        htmlBody: (this.advancedForm.emailBody as any).getHTML(),
        firstname: user.firstName,
        lastname: user.lastName,
        email: user.email,
      };
      await this._invite(option);

      ElMessage({
        message:
          // "A test email has been sent to your inbox at {admin_account_email}",
        "A test email has been sent to your inbox at " + user.email,
        type: "success",
      });
    },
    handlePaste(event: any) {
      event.preventDefault();
      const clipboardData =
        event.clipboardData || (window as any).clipboardData;
      const pastedData = clipboardData.getData("Text");
      this.processPastedData(pastedData);
    },
    processPastedData(pastedData: string) {
      const rows = pastedData.split(/\r\n|\n|\r/);
      interface Recipient {
        firstname: string;
        lastname: string;
        email: string;
      }
      let newRecipients: Recipient[] = [];

      rows.forEach((row) => {
        const columns = row.split("\t");
        if (columns.length >= 3) {
          newRecipients.push({
            firstname: columns[0],
            lastname: columns[1],
            email: columns[2],
          });
        }
      });

      if (this.advancedForm.recipients.length + newRecipients.length > 100) {
        ElMessage({
          message: (this as any).$t("popup.message.message_20w"),
          type: "warning",
        });
        return;
      }

      this.advancedForm.recipients =
        this.advancedForm.recipients.concat(newRecipients);

      this.removeEmptyValues();

      if (this.advancedForm.recipients.length < 100) {
        this.advancedForm.recipients.push({
          firstname: "",
          lastname: "",
          email: "",
        });
      }
    },
    addRecipient() {
      if (this.advancedForm.recipients.length < 100) {
        this.advancedForm.recipients.push({
          firstname: "",
          lastname: "",
          email: "",
        });
      } else {
        ElMessage({
          message: (this as any).$t("popup.message.message_20w"),
          type: "warning",
        });
      }
    },
    removeEmptyValues() {
      this.advancedForm.recipients = this.advancedForm.recipients.filter(
        (item) =>
          // @see https://trello.com/c/KbKmF0FO/1662-invites-as-a-company-i-want-to-customize-the-invitation-email-so-that-i-can-share-assessments-with-a-personal-welcome-message-wi
          // First name and Last name are optional but a valid email address is required for each row.
          //
          // item.firstname.trim() !== "" &&
          // item.lastname.trim() !== "" &&
          item.email.trim() !== ""
      );
    },
    isDuplicateEmail(email: string, index: number) {
      if (email.trim() === "" || !email) return false;
      return (
        this.advancedForm.recipients.findIndex(
          (item, idx) => item.email === email && idx !== index
        ) !== -1
      );
    },
  },
  beforeUnmount() {
    (this.advancedForm as any).emailBody.destroy();
  },
});
